import { render, staticRenderFns } from "./TabelDokumentasi.vue?vue&type=template&id=8c4efd12&scoped=true"
import script from "./TabelDokumentasi.vue?vue&type=script&lang=js"
export * from "./TabelDokumentasi.vue?vue&type=script&lang=js"
import style0 from "./TabelDokumentasi.vue?vue&type=style&index=0&id=8c4efd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4efd12",
  null
  
)

export default component.exports